/**
 * moment 模块提供时间格式化相关的接口
 * @module moment
 */

const _supplementZero = value => value < 10 ? '0' + value : value;

/**
 * 格式化时间对象
 * @method formatDateObj
 * @param {Date|String|Number} time Date对象|时间字符串|时间戳
 * @return {Object} 格式化后的时间对象
 */
export const formatDateObj = (time = new Date()) => {
  const date = new Date(time);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hours = date.getHours();
  const min = date.getMinutes();
  const sec = date.getSeconds();

  return { year, month, day, hours, min, sec };
};

/**
 * 格式化日期
 * @method formatDay
 * @param {Date|String|Number} time Date对象|时间字符串|时间戳
 * @param {String} [separator='-'] 年月日分隔符
 * @return {Object} 格式化后的日期（xxxx-xx-xx）
 */
export const formatDay = (time = new Date(), separator = '-') => {
  const { year, month, day } = formatDateObj(time);
  return year + separator + _supplementZero(month) + separator + _supplementZero(day);
};

/**
 * 格式化时间
 * @method formatTime
 * @param {Date|String|Number} time Date对象|时间字符串|时间戳
 * @param {String} [separator='-'] 年月日分隔符
 * @return {Object} 格式化后的时间（xxxx-xx-xx xx:xx:xx）
 */
export const formatTime = (time = new Date(), separator = '-') => {
  const { year, month, day, hours, min, sec } = formatDateObj(time);
  return `${year + separator + _supplementZero(month) + separator + _supplementZero(day)} ${_supplementZero(hours)}:${_supplementZero(min)}:${_supplementZero(sec)}`;
};

/**
 * 是否为当日
 * @method hasToday
 * @param {Date|String|Number} time Date对象|时间字符串|时间戳
 * @return {Object} true-是当日 false-不是当日
 */
export const hasToday = time => {
  const timeDay = formatDay(time);
  const today = formatDay(+new Date());

  return timeDay === today;
};
